import { IDefineCommand } from 'core-ts-types';
import { APGenericSlot } from '../../../builders/ap_generic_slot_builder';
import { MarkAsMetSlotModel } from '../models/mark_as_met_slot_model';

angular
  .module('capability-ng-academic-planner')
  .factory('setMarkAsMetSlotCommand', (defineCommandORM: IDefineCommand, ngMarkAsMetSlotModel: MarkAsMetSlotModel) =>
    defineCommandORM('setMarkAsMetSlotCommand', (deferred, slot: APGenericSlot) => {
      ngMarkAsMetSlotModel.clear().write({ currentSlot: slot });
      deferred.resolve();
    })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/commands/set_mark_as_met_slot_command.ts